// for preloading the loader image

const GiraffeLoaderImagePreload = () => {
  return (
    <img
      src="/assets/giraffe-loader-animated.gif"
      style={{ width: "1px", height: "1px", opacity: 0.0 }}
    />
  );
};

export default GiraffeLoaderImagePreload;
